import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=60e9538a"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60e9538a')) {
      api.createRecord('60e9538a', component.options)
    } else {
      api.reload('60e9538a', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=60e9538a", function () {
      api.rerender('60e9538a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/stock/synchronization/detail.vue"
export default component.exports